import { SVGProps } from 'react';
const SvgDiscord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_917_409)">
      <path
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#5865F2"
      />
      <path
        d="M33.8824 14.8294C32.0374 13.9744 30.0724 13.3444 28.0024 12.9844C27.7474 13.4344 27.4474 14.0494 27.2524 14.5444C25.0624 14.2144 22.8874 14.2144 20.7426 14.5444C20.5326 14.0494 20.2326 13.4344 19.9776 12.9844C17.9076 13.3444 15.9426 13.9744 14.0975 14.8294C10.3775 20.4394 9.37254 25.9144 9.86754 31.2994C12.3425 33.1444 14.7275 34.2544 17.0826 34.9894C17.6676 34.1944 18.1776 33.3394 18.6276 32.4544C17.7726 32.1394 16.9626 31.7344 16.1976 31.2694C16.4076 31.1194 16.6026 30.9544 16.7976 30.8044C21.4924 32.9944 26.5774 32.9944 31.2124 30.8044C31.4074 30.9694 31.6024 31.1194 31.8124 31.2694C31.0474 31.7344 30.2225 32.1244 29.3825 32.4544C29.8324 33.3394 30.3424 34.1944 30.9276 34.9894C33.2824 34.2544 35.6824 33.1444 38.1424 31.2994C38.7274 25.0444 37.1374 19.6294 33.9124 14.8294H33.8824ZM19.2576 27.9994C17.8476 27.9994 16.6926 26.6944 16.6926 25.0894C16.6926 23.4844 17.8176 22.1794 19.2576 22.1794C20.6976 22.1794 21.8374 23.4844 21.8224 25.0894C21.8224 26.6794 20.6976 27.9994 19.2576 27.9994ZM28.7224 27.9994C27.3124 27.9994 26.1574 26.6944 26.1574 25.0894C26.1574 23.4844 27.2824 22.1794 28.7224 22.1794C30.1624 22.1794 31.3026 23.4844 31.2874 25.0894C31.2874 26.6794 30.1624 27.9994 28.7224 27.9994Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_917_409">
        <rect width={48} height={48} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDiscord;
